import React, { useState } from 'react';
import Input from '../Input';

import { ReactComponent as VisibilityOn } from '../../assets/visibility_black_24dp.svg';
import { ReactComponent as VisibilityOffIcon } from '../../assets/visibility_off_black_24dp.svg';

const InputPassword = ({
  id,
  password,
  setPassword,
  labelName,
  placeholder,
  isError,
  isErrorMessage,
  marginTop,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  function togglePasswordInput() {
    setShowPassword(!showPassword);
  }

  function handleIconPassword() {
    if (showPassword) {
      return <VisibilityOffIcon />;
    }

    return <VisibilityOn />;
  }

  return (
    <Input
      value={password}
      setValue={setPassword}
      onClickRightIcon={togglePasswordInput}
      labelName={labelName}
      placeholder={placeholder}
      type={showPassword ? 'text' : 'password'}
      id={id}
      required
      disabled={disabled}
      size='100%'
      RightIcon={handleIconPassword}
      topRightIcon={'8px'}
      handleInputChange={(e) => setPassword(e.currentTarget.value)}
      error={isError}
      errorMessage={isErrorMessage}
      marginTop={marginTop}
    />
  );
};

export default InputPassword;
